let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kZ9Jj")).then(() => parcelRequire('cvwB6'));